import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// aos
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../Layout/Layout";
import { viewNews } from "../../states/actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../loading/Loading";
import BaseUrl from "../../service/API/base_url";
import { Search, ChevronRight } from "lucide-react";
import Profile from "../../assets/profile.jpg";
import PaginationComponent from "../Pagination/Pagination";
import {
  FaGavel,
  FaBriefcase,
  FaHome,
  FaBalanceScale,
  FaShieldAlt,
  FaGlobe,
} from "react-icons/fa";
import { FormatDate } from "../Date/Date";

const NewsDetail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 3000 });
  }, []);

  // dispatch
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // hooks
  const News = useSelector((state) => state.News);
  // use effect
  useEffect(() => {
    dispatch(viewNews());
  }, []);

  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  //change useselector data to useState states with react js
  useEffect(() => {
    if (News?.News) {
      setOriginalData(News.News);
      setData(News.News);
      setLoading(false);
    }
  }, [News?.News]);

  const [selectedOption, setSelectedOption] = useState(null);
  // searching state
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    let timer;
    if (isSearching) {
      timer = setTimeout(() => {
        setIsSearching(false);
      }, 3000); // stop searching after 30s
    }
    return () => clearTimeout(timer);
  }, [isSearching]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = data?.slice(startIndex, startIndex + itemsPerPage);
  // console.log("all new : ", currentItems);
  const handleGetDetail = (singleNews) => {
    // const orderData = { ...data, table: "technology" };
    navigate(`/news-detail/${singleNews.id}`, { state: { singleNews } });
  };

  const goldBtn =
    "bg-[#C9A227] hover:bg-[#F6A227] text-white text-xs tracking-wide px-6 py-2 rounded-full transition-all duration-300";

  // --- Post Card ---
  const PostCard = ({ post }) => (
    <div className="bg-white border border-gray-200 mb-12 p-2 md:p-4">
      <img
        src={`${BaseUrl}${post.photo}`}
        alt={post.title}
        className="w-full h-[260px] md:h-[360px] object-cover"
      />

      <div className="p-6 md:p-8">
        <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500 mb-4">
          <div className="flex items-center gap-2">
            <img
              src={Profile}
              alt="Profile img"
              className="w-7 h-7 rounded-full object-cover"
            />
            <span>{post.author}</span>
          </div>

          <span>•</span>
          <span>{new Date(post.createdAt).toLocaleDateString()}</span>
        </div>

        <h2 className="text-xl md:text-2xl font-serif font-semibold text-gray-800 mb-4 leading-snug hover:text-[#c6a47e] cursor-pointer">
          {post.title}
        </h2>

        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          {post.description?.slice(0, 120)}...
        </p>

        <button onClick={() => handleGetDetail(post)} className={goldBtn}>
          READ MORE
        </button>
      </div>
    </div>
  );

  // --- Sidebar ---
  const Sidebar = () => (
    <div className="space-y-10">
      {/* Search with Icon */}
      <div className="border border-gray-200 p-5">
        <div className="relative">
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search..."
            className="w-full border px-3 py-2 pr-10 text-sm outline-none focus:border-[#c6a47e]"
          />
        </div>
      </div>

      {/* Categories with Arrow Icon */}
      <div className="border border-gray-200 p-5">
        <h3 className="font-semibold mb-4">Categories</h3>
        <ul className="text-sm text-gray-600 divide-y">
          {[
            "Criminal Law (4)",
            "Employment Law (6)",
            "Family Law (5)",
            "Financial Law (8)",
            "Vaccine Claims (6)",
          ].map((item, i) => (
            <li
              key={i}
              className="py-2 flex items-center justify-between group cursor-pointer"
            >
              <span className="group-hover:text-[#c6a47e]">{item}</span>
              <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-[#c6a47e]" />
            </li>
          ))}
        </ul>
      </div>

      {/* Recent Posts */}
      <div className="border border-gray-200 p-5">
        <h3 className="font-semibold mb-4">Recent Posts</h3>
        <div className="space-y-4">
          {data?.slice(0, 4)?.map((p) => (
            <div
              key={p.id}
              className="flex gap-3 items-center"
              onClick={() => handleGetDetail(p)}
            >
              <img
                src={`${BaseUrl}${p.photo}`}
                alt="news image"
                className="w-14 h-14 object-cover"
              />
              <div>
                <p className="text-sm font-medium leading-tight hover:text-[#c6a47e] cursor-pointer">
                  {p.title}
                </p>
                <span className="text-xs text-gray-400">{p.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tags */}
      <div className="border border-gray-200 p-5">
        <h3 className="font-semibold mb-4">Tags</h3>
        <div className="flex flex-wrap gap-2">
          {[
            "Accident",
            "Attorney",
            "Business",
            "Corporate",
            "Law",
            "Lawyer",
            "Popular",
          ].map((tag) => (
            <span
              key={tag}
              className="text-xs border px-3 py-1 hover:bg-[#c6a47e] hover:text-white cursor-pointer transition"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );

  const practiceAreas = [
    {
      title: "Family & Inheritance Law",
      desc: "Guidance for marriage, divorce, inheritance, and estate management.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Litigation & Arbitration",
      desc: "Representation in civil, criminal, commercial disputes, and arbitration.",
      icon: <FaGavel />,
    },
    {
      title: "Corporate & Commercial Law",
      desc: "Business formation, transactions, and corporate governance.",
      icon: <FaBriefcase />,
    },
    {
      title: "Property & Real Estate Law",
      desc: "Legal support for land acquisition, development, and registration.",
      icon: <FaHome />,
    },
    {
      title: "Criminal & Human Rights Law",
      desc: "Defense representation and advocacy for constitutional human rights.",
      icon: <FaShieldAlt />,
    },
    {
      title: "International & Immigration",
      desc: "Guidance on visas, residency, permits, and cross-border compliance.",
      icon: <FaGlobe />,
    },
  ];

  return (
    <Layout
      title="News Page | Aderaw Addisu Law Office"
      description="Legal services in Bahir Dar including arbitration, litigation, contracts and consultation."
      keywords="Legal services Bahir Dar, Lawyer Ethiopia"
    >
      <section className="h-[30vh] md:h-[55vh] bg-gradient-to-b from-[#1e2f4a] to-[#0b1628] text-white flex items-center justify-center px-6">
        <div className="max-w-5xl w-full text-center">
          {/* Top Badge */}
          <div className="inline-block mb-6">
            <span className="text-[11px] tracking-widest uppercase px-5 py-2 rounded-full border border-yellow-500/40 text-yellow-400">
              News and Events
            </span>
          </div>
          {/* Title */}

          <h1 className="text-4xl md:text-6xl font-light mb-6 leading-tight font-serif">
            Recent
            <span className="text-yellow-400 font-serif font-medium tracking-tight">
              Posts
            </span>
          </h1>
        </div>
      </section>
      <div className="bg-[#f8f8f8] min-h-screen py-10 px-4 md:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            {loading ? (
              <Loading />
            ) : currentItems?.length > 0 ? (
              currentItems.map((post) => <PostCard key={post.id} post={post} />)
            ) : (
              <p className="text-center text-gray-500">No News Found</p>
            )}

            <PaginationComponent
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          <div className="hidden lg:block">
            <Sidebar />
          </div>
        </div>

        <div className="lg:hidden mt-12">
          <Sidebar />
        </div>
      </div>

      <section className="bg-[#f8f8f8] py-16 px-6 md:px-16 relative overflow-hidden">
        {/* Title */}
        <h2 className="text-center text-3xl md:text-4xl font-serif text-[#5B2E0F] mb-12">
          Our Practice Areas,
        </h2>

        {/* Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {practiceAreas.map((item, index) => (
            <div
              key={index}
              className="bg-[#F4DFC2] rounded-xl p-8 text-center border border-[#C68B3C] shadow-[6px_6px_0px_#C68B3C] hover:shadow-[8px_8px_0px_#A66E2E] transition duration-300"
            >
              {/* Icon */}
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-lg bg-gradient-to-b from-[#D39A4B] to-[#A6631A] text-white text-xl shadow-md">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-[#1C2B39] mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-[#2F3E4D] leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Link */}
        <div className="text-center mt-10">
          <a
            href="/about-us"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#1C2B39] font-medium hover:underline"
          >
            See More in Details →
          </a>
        </div>
      </section>
    </Layout>
  );
};
export default NewsDetail;
